'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _site = require('../../actions/site');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
var _Grid = require('@material-ui/core/Grid');
var _Grid2 = _interopRequireDefault(_Grid);
var _moment = require('moment');
var _moment2 = _interopRequireDefault(_moment);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
var _reactI18next = require('react-i18next');
var _Paginator = require('../Paginator');
var _Paginator2 = _interopRequireDefault(_Paginator);
var _styles = require('@material-ui/core/styles');
require('moment/locale/fr');
require('moment/locale/es');
var _Button = require('@material-ui/core/Button');
var _Button2 = _interopRequireDefault(_Button);
var _reactRedux = require('react-redux');
var _CustomModal = require('../CustomModal');
var _CustomModal2 = _interopRequireDefault(_CustomModal);
var _B2BModalContent = require('../B2BModalContent');
var _B2BModalContent2 = _interopRequireDefault(_B2BModalContent);
var _misc = require('../../helpers/misc');
var _isEmpty = require('lodash/isEmpty');
var _isEmpty2 = _interopRequireDefault(_isEmpty);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  B2BMatchmaking: {
    textAlign: 'center',
    margin: 'auto',
    padding: '3rem 1rem',
    backgroundColor: function backgroundColor(_ref) {
      var _backgroundColor = _ref.otherProperties.backgroundColor;
      return _backgroundColor;
    }
  },
  participantGrid: {
    marginBottom: function marginBottom(props) {
      return getParticipantMarginBottom(props);
    }
  },
  paper: {
    backgroundColor: '#FFFFFF',
    position: 'absolute',
    width: '75%',
    maxWidth: '85%',
    boxShadow: '0 0 16px #B4B4B4',
    padding: '1rem',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'auto',
    maxHeight: '85%'
  },
  modalB2B: {
    width: '90%',
    margin: '0 auto',
    fontSize: function fontSize(_ref2) {
      var responsiveMode = _ref2.responsiveMode;
      return responsiveMode === _ResponsiveModes.DESKTOP ? '16px' : '14px';
    },
    '& .img-wrapper': {
      display: 'block',
      '& .modal-logo': {
        height: '7rem',
        maxWidth: '100%',
        textAlign: 'center',
        display: 'block',
        objectFit: 'contain',
        margin: 'auto'
      }
    },
    '& .modal-info': {
      '& .modal-paragraph': {
        '& span': {
          display: 'block',
          '& .profile-custom-field-image': {
            maxWidth: '80%',
            objectFit: 'contain'
          }
        }
      }
    }
  },
  grid: {
    margin: '0 auto',
    maxWidth: function maxWidth(props) {
      return getMaxWidth(props);
    }
  },
  participant: {
    margin: '20px auto',
    height: '100%',
    cursor: 'pointer',
    position: 'relative',
    backgroundColor: function backgroundColor(_ref3) {
      var secondaryBackgroundColor = _ref3.otherProperties.secondaryBackgroundColor;
      return secondaryBackgroundColor;
    },
    border: function border(_ref4) {
      var borderColor = _ref4.otherProperties.borderColor;
      return '1px solid ' + borderColor;
    },
    boxShadow: function boxShadow(_ref5) {
      var itemOuterShadow = _ref5.otherProperties.itemOuterShadow;
      return '0px 0px 30px ' + itemOuterShadow;
    },
    maxWidth: function maxWidth(props) {
      return getParticipantMaxWidth(props);
    },
    pointerEvents: function pointerEvents(_ref6) {
      var editable = _ref6.editable;
      return !editable ? 'auto' : 'none';
    },
    '& .info': {
      padding: '0rem',
      color: '#9a9a9a',
      '& .img-wrapper': {
        margin: '0 auto',
        display: 'table',
        padding: '0.55rem',
        backgroundColor: function backgroundColor(_ref7) {
          var itemBackgroundColor = _ref7.otherProperties.itemBackgroundColor;
          return itemBackgroundColor;
        },
        '& .logo': {
          height: '7rem',
          width: '100%',
          textAlign: 'center',
          display: 'block',
          objectFit: 'contain'
        }
      },
      '& .specific-info': {
        padding: '0.1rem',
        minHeight: '4.82rem',
        color: function color(_ref8) {
          var _color = _ref8.otherProperties.color;
          return _color;
        },
        '& .item': {
          margin: '0rem',
          padding: '0.1rem 0.5rem',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          fontSize: function fontSize(_ref9) {
            var _fontSize = _ref9.otherProperties.fontSize;
            return _fontSize;
          }
        }
      }
    }
  },
  noParticipant: {
    padding: '2rem'
  },
  progress: {
    margin: '0 auto'
  }
};
var DEFAULT_ATTENDEE = 'default_attendee';
var CUSTOM_ATTENDEE = 'custom_attendee';
var CUSTOM_PARTICIPANT = 'custom_participant';
var getMaxWidth = function getMaxWidth(props) {
  var responsiveMode = props.responsiveMode,
    otherProperties = props.otherProperties;
  var defaultWidth = '100%';
  if (!otherProperties) return defaultWidth;
  var participantsPerRowTablet = otherProperties.participantsPerRowTablet,
    participantsPerRowDesktop = otherProperties.participantsPerRowDesktop;
  switch (responsiveMode) {
    case _ResponsiveModes.DESKTOP:
      return participantsPerRowDesktop === 3 ? '55rem' : participantsPerRowDesktop === 4 ? '70rem' : defaultWidth;
    case _ResponsiveModes.TABLET:
      return participantsPerRowTablet === 2 ? '36rem' : participantsPerRowTablet === 3 ? '45rem' : defaultWidth;
    default:
      return defaultWidth;
  }
};
var getParticipantMaxWidth = function getParticipantMaxWidth(props) {
  var responsiveMode = props.responsiveMode,
    otherProperties = props.otherProperties;
  var defaultWidth = '15rem';
  if (!otherProperties) return defaultWidth;
  var participantsPerRowMobile = otherProperties.participantsPerRowMobile,
    participantsPerRowTablet = otherProperties.participantsPerRowTablet,
    participantsPerRowDesktop = otherProperties.participantsPerRowDesktop;
  if (responsiveMode === _ResponsiveModes.MOBILE && participantsPerRowMobile === 2) defaultWidth = '10rem';
  if (responsiveMode === _ResponsiveModes.MOBILE && participantsPerRowMobile === 3) defaultWidth = '7.1rem';
  if (responsiveMode === _ResponsiveModes.TABLET && participantsPerRowTablet === 4) defaultWidth = '11rem';
  if (responsiveMode === _ResponsiveModes.TABLET && participantsPerRowTablet === 3) defaultWidth = '12rem';
  if (responsiveMode === _ResponsiveModes.DESKTOP && participantsPerRowDesktop === 6) defaultWidth = '12rem';
  return defaultWidth;
};
var getParticipantMarginBottom = function getParticipantMarginBottom(props) {
  var responsiveMode = props.responsiveMode,
    otherProperties = props.otherProperties;
  var defaultMargin = '3rem';
  if (!otherProperties) return defaultMargin;
  var participantsPerRowMobile = otherProperties.participantsPerRowMobile,
    participantsPerRowTablet = otherProperties.participantsPerRowTablet;
  if (responsiveMode === _ResponsiveModes.MOBILE && participantsPerRowMobile === 2) defaultMargin = '1.8rem';
  if (responsiveMode === _ResponsiveModes.MOBILE && participantsPerRowMobile === 3) defaultMargin = '0.8rem';
  if (responsiveMode === _ResponsiveModes.TABLET && participantsPerRowTablet === 4) defaultMargin = '1.8rem';
  return defaultMargin;
};
var B2BMatchmaking = function (_Component) {
  _inherits(B2BMatchmaking, _Component);
  function B2BMatchmaking(props) {
    _classCallCheck(this, B2BMatchmaking);
    var _this = _possibleConstructorReturn(this, (B2BMatchmaking.__proto__ || Object.getPrototypeOf(B2BMatchmaking)).call(this, props));
    _this.handleFetchParticipant = function (page) {
      var _this$props = _this.props,
        otherProperties = _this$props.otherProperties,
        entities = _this$props.entities,
        fetchData = _this$props.fetchData;
      var participantInformation = otherProperties.participantInformation;
      if (!participantInformation || !participantInformation.selectedParticipants) {
        fetchData((0, _site.fetchParticipants)(page, {
          only_confirmed: true
        }));
      } else {
        var business_conference_participant_types = entities.business_conference_participant_types;
        if (!business_conference_participant_types) return;
        // query string that contains the ptype ids as filter params in the Api call
        var participant_type_id = '';
        var allTypes = Object.keys(business_conference_participant_types);
        for (var i = 0; i < allTypes.length; i++) {
          var checked = participantInformation.selectedParticipants[allTypes[i]];
          if (typeof checked === "undefined" || !!checked) {
            participant_type_id = participant_type_id + allTypes[i].toString() + ',';
          }
        }
        participant_type_id = participant_type_id.slice(0, -1);
        fetchData((0, _site.fetchParticipants)(page, {
          participant_type_id: participant_type_id,
          only_confirmed: true
        }));
      }
    };
    _this.handleClose = function () {
      _this.setState({
        currentParticipantId: 0
      });
    };
    _this.showModal = function (id) {
      _this.setState({
        currentParticipantId: id
      });
    };
    _this.getColumnSize = function () {
      var _this$props2 = _this.props,
        responsiveMode = _this$props2.responsiveMode,
        otherProperties = _this$props2.otherProperties;
      var participantsPerRowDesktop = otherProperties.participantsPerRowDesktop,
        participantsPerRowTablet = otherProperties.participantsPerRowTablet,
        participantsPerRowMobile = otherProperties.participantsPerRowMobile;
      var column_size = null;
      switch (responsiveMode) {
        case _ResponsiveModes.DESKTOP:
          column_size = 12 / (participantsPerRowDesktop || 4);
          break;
        case _ResponsiveModes.TABLET:
          column_size = 12 / (participantsPerRowTablet || 2);
          break;
        case _ResponsiveModes.MOBILE:
        default:
          column_size = 12 / (participantsPerRowMobile || 1);
      }
      return column_size;
    };
    _this.renderParticipantTemplateCard = function (participant, info) {
      var _this$props3 = _this.props,
        entities = _this$props3.entities,
        responsiveMode = _this$props3.responsiveMode,
        otherProperties = _this$props3.otherProperties,
        classes = _this$props3.classes;
      var attendees = entities.attendees,
        custom_fields = entities.attendee_type_custom_fields;
      var participantInformation = otherProperties.participantInformation;
      var id = participant.id,
        logo = participant.logo,
        attendeeId = participant.attendeeId;
      var attendee = attendees && attendees[attendeeId];
      var attendeeAnswers = attendee && attendee.fields;
      var attendeeAnswersIds = Object.keys(attendeeAnswers || {});
      var headshotFieldId = custom_fields && attendeeAnswersIds.find(function (id) {
        return custom_fields[id] && custom_fields[id].name === 'headshot';
      });
      var headshot = attendeeAnswers && attendeeAnswers[headshotFieldId] && attendeeAnswers[headshotFieldId].filename ? attendeeAnswers[headshotFieldId].large : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/company_logo.png';
      var logoStyle = logo.filename ? logo.large : headshot;
      var columnSize = _this.getColumnSize();
      return _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: columnSize,
        key: id,
        className: classes.participantGrid
      }, _react2.default.createElement('div', {
        key: id,
        id: id,
        onClick: function onClick() {
          _this.showModal(id);
        },
        className: classes.participant
      }, _react2.default.createElement('div', {
        className: 'info'
      }, _react2.default.createElement('div', {
        className: 'img-wrapper'
      }, _react2.default.createElement('img', {
        className: 'logo',
        src: logoStyle
      })), _react2.default.createElement('div', {
        className: 'specific-info'
      }, !!info ? info.map(function (item, index) {
        return _react2.default.createElement('p', {
          className: 'item',
          key: index
        }, item);
      }) : _this.getAttendeeBasicInfo(id).map(function (item, index) {
        return _react2.default.createElement('p', {
          className: 'item',
          key: index
        }, item);
      })))));
    };
    _this.replacePatterns = function (attendee, participant, rawText, patterns) {
      var joinedRawText = rawText.join('\n');
      // suposse patterns are ordered by rawText ocurrence
      for (var i = 0; i < patterns.length; i++) {
        if (patterns[i].type === CUSTOM_PARTICIPANT) {
          var answer = participant.profileExtraFields[patterns[i].id] || '';
          joinedRawText = joinedRawText.replace(patterns[i].patternString, answer.constructor === Array ? answer.join(', ') : (0, _misc.isObject)(answer) ? answer.originalUrl : answer);
        } else if (patterns[i].type === CUSTOM_ATTENDEE || patterns[i].type === DEFAULT_ATTENDEE) {
          var _answer = attendee.fields[patterns[i].id] || '';
          joinedRawText = joinedRawText.replace(patterns[i].patternString, _answer.constructor === Array ? _answer.join(', ') : (0, _misc.isObject)(_answer) ? _answer.originalUrl : _answer);
        }
      }
      return joinedRawText.split('\n');
    };
    _this.showParticipant = function (participant) {
      var _this$props4 = _this.props,
        entities = _this$props4.entities,
        otherProperties = _this$props4.otherProperties,
        classes = _this$props4.classes;
      var participantsPerRowDesktop = otherProperties.participantsPerRowDesktop,
        participantsPerRowTablet = otherProperties.participantsPerRowTablet,
        participantsPerRowMobile = otherProperties.participantsPerRowMobile,
        participantInformation = otherProperties.participantInformation;
      var attendees = entities.attendees;

      // Render an empty participant card (with logo)

      if (!participantInformation) return _this.renderParticipantTemplateCard(participant);

      // Get the attendee type for the current participant card
      var currentAttendee = attendees[participant.attendeeId];
      var currentAttendeeType = null;
      if (!!currentAttendee) currentAttendeeType = currentAttendee.attendeeType.id;

      // Get the raw text wrote in text area for the current attendee type
      var rawText = participantInformation.displayedValue[currentAttendeeType];
      // Render an empty participant card (with logo)
      if (!rawText) return _this.renderParticipantTemplateCard(participant);

      // Get a data structure with each ${certainField} for the current attendee type
      var patterns = participantInformation.selectedFields[currentAttendeeType];
      // Render an empty participant card (with logo)
      if (!patterns) return _this.renderParticipantTemplateCard(participant, rawText);
      var processedText = _this.replacePatterns(currentAttendee, participant, rawText, patterns);
      // Render with the information dropped or wrote in the property
      return _this.renderParticipantTemplateCard(participant, processedText);
    };
    _this.getAttendeeBasicInfo = function (participantId) {
      var entities = _this.props.entities;
      // Because participant entity is fetched at first on componentDidMount

      if (!entities) return [];
      var participants = entities.business_conference_participants;
      if (!participants || (0, _isEmpty2.default)(participants)) return [];
      var participant = participants[participantId];
      if (!participant) return [];
      // these elements are the basic fields
      var fields = [];
      fields.push(participants[participantId].profileContactName);
      fields.push(participants[participantId].profileContactEmail);
      fields.push(participants[participantId].profileDisplayName);
      fields.push(participants[participantId].participantTypeName);
      return fields;
    };
    _this.getModalInfo = function (participantId) {
      var entities = _this.props.entities;
      // Because of participant entity is fetched at first on componentDidMount

      if (!entities) return [null, null, null, null, null];
      var attendees = entities.attendees,
        attendee_types = entities.attendee_types,
        custom_fields = entities.attendee_type_custom_fields,
        participant_types = entities.business_conference_participant_types,
        participants = entities.business_conference_participants,
        profile_fields = entities.business_conference_profile_fields;
      if (!participants) return [null, null, null, null, null];
      var blackList = ['city_id', 'headshot'];
      var participant = participants[participantId];
      var attendee = attendees[participant.attendeeId];
      var participantAnswers = participant.profileExtraFields;
      var attendeeAnswers = attendee.fields;
      var logo = participant.logo,
        attendeeId = participant.attendeeId;
      var attendeeAnswersIds = Object.keys(attendeeAnswers || {}),
        attendeeFields = {};
      var headshotFieldId = custom_fields && attendeeAnswersIds.find(function (id) {
        return custom_fields[id] && custom_fields[id].name === 'headshot';
      });
      var headshot = attendeeAnswers && attendeeAnswers[headshotFieldId] && attendeeAnswers[headshotFieldId].filename ? attendeeAnswers[headshotFieldId].small : 'https://s3.amazonaws.com/eventtia-composer/assets/images/icons/company_logo.png';
      var participantAnswersIds = Object.keys(participantAnswers),
        participantFields = {};
      for (var i = 0; i < participantAnswersIds.length; i++) {
        var current_field = profile_fields[participantAnswersIds[i]];
        if (current_field.displayOnProfile) participantFields[participantAnswersIds[i]] = current_field;
      }
      for (var _i = 0; _i < attendeeAnswersIds.length; _i++) {
        var _current_field = custom_fields[attendeeAnswersIds[_i]];
        if (_current_field.availablePublicListings && blackList.indexOf(_current_field.name) === -1) attendeeFields[attendeeAnswersIds[_i]] = _current_field;
      }
      var logoURL = logo.filename ? logo.small : headshot;
      return [logoURL, participantAnswers, attendeeAnswers, participantFields, attendeeFields];
    };
    _this.state = {
      currentParticipantId: 0
    };
    _this.wrapperRef = _react2.default.createRef();
    return _this;
  }
  _createClass(B2BMatchmaking, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var entities = this.props.entities;
      var business_conference_participant_types = entities.business_conference_participant_types;
      this.handleFetchParticipant(null);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
        otherProperties = _props.otherProperties,
        entities = _props.entities;
      var participantInformation = otherProperties.participantInformation;
      var business_conference_participant_types = entities.business_conference_participant_types;
      if (!prevProps.entities.business_conference_participant_types && !!business_conference_participant_types || prevProps.otherProperties.participantInformation.selectedParticipants !== participantInformation.selectedParticipants) {
        this.handleFetchParticipant(null);
      }
    }

    // Feb 22 / Cristian Ospina
    // Render the text information for each participant card

    // attendee provides answers, same to parcitipant. Rawtext is the text with ${} like patterns
    // and patterns is a data structure for help to translate rawtext to text without ${}
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      _moment2.default.locale(this.props.i18n.language);
      if (this.props.i18n.language === 'es') _moment2.default.updateLocale('es', {
        ordinal: '%d'
      });
      var _props2 = this.props,
        classes = _props2.classes,
        responsiveMode = _props2.responsiveMode,
        t = _props2.t,
        entities = _props2.entities,
        pagination = _props2.pagination,
        otherProperties = _props2.otherProperties,
        editable = _props2.editable;
      var participantsPerRowDesktop = otherProperties.participantsPerRowDesktop,
        participantsPerRowTablet = otherProperties.participantsPerRowTablet,
        participantsPerRowMobile = otherProperties.participantsPerRowMobile,
        participantInformation = otherProperties.participantInformation;
      var isFetching = pagination.isFetching,
        idsByPage = pagination.idsByPage,
        links = pagination.links;
      var currentPage = links.self;
      var attendees = entities.attendees,
        business_conference_participant_types = entities.business_conference_participant_types;
      var participants = !!idsByPage && !!idsByPage[currentPage] && idsByPage[currentPage].map(function (id) {
        return entities.business_conference_participants[id];
      });

      // All the information of the clicked participant
      var logoURL = void 0,
        participantAnswers = void 0,
        attendeeAnswers = void 0,
        participantFields = void 0,
        attendeeFields = void 0;
      if (!!this.state.currentParticipantId && !!entities && !!participants) {
        var _getModalInfo = this.getModalInfo(this.state.currentParticipantId);
        var _getModalInfo2 = _slicedToArray(_getModalInfo, 5);
        logoURL = _getModalInfo2[0];
        participantAnswers = _getModalInfo2[1];
        attendeeAnswers = _getModalInfo2[2];
        participantFields = _getModalInfo2[3];
        attendeeFields = _getModalInfo2[4];
      }
      return _react2.default.createElement('div', {
        className: classes.B2BMatchmaking,
        ref: this.wrapperRef
      }, !!this.state.currentParticipantId && _react2.default.createElement(_CustomModal2.default, {
        onClose: this.handleClose
      }, _react2.default.createElement(_B2BModalContent2.default, {
        logoURL: logoURL,
        participantAnswers: participantAnswers,
        attendeeAnswers: attendeeAnswers,
        participantFields: participantFields,
        attendeeFields: attendeeFields,
        responsiveMode: responsiveMode
      })), !!participantInformation && participantInformation.length > 0 && participantInformation.map(function (rowInfo, index) {
        return _react2.default.createElement('p', {
          key: index
        }, rowInfo);
      }), _react2.default.createElement(_Grid2.default, {
        container: true,
        className: classes.grid,
        direction: 'row',
        justify: 'flex-start',
        alignItems: 'stretch'
      }, isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.progress,
        size: 50
      }) : participants && !!participants.length ? participants.map(function (participant) {
        return _this2.showParticipant(participant);
      }) : !!editable && _react2.default.createElement('h3', {
        className: classes.noParticipant
      }, t('b2b.create_conference_and_participant'))), participants && !!participants.length && (links.next || links.prev) && _react2.default.createElement(_Paginator2.default, _extends({
        parentRef: this.wrapperRef,
        fetchPage: this.handleFetchParticipant
      }, links)));
    }
  }]);
  return B2BMatchmaking;
}(_react.Component);
var mapDispatchToProps = function mapDispatchToProps(dispatch, state) {
  return {
    fetchData: function fetchData(action) {
      return dispatch(action);
    }
  };
};
exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(B2BMatchmaking)));